import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import TaskCard from './TaskCard';

const TaskColumn = ({ id, title, tasks, color }) => {
    const { setNodeRef, isOver } = useDroppable({
        id: id,
    });

    return (
        <Paper
            ref={setNodeRef}
            elevation={0}
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: isOver ? `${color}20` : '#f7fafc',
                border: '2px dashed',
                borderColor: isOver ? color : 'transparent',
                borderRadius: 4, // Match TaskCard
                overflow: 'hidden',
                transition: 'all 0.2s',
                minWidth: 300
            }}
        >
            <Box sx={{ p: 2, bgcolor: color, color: 'white' }}>
                <Typography variant="h4" fontWeight="bold" textAlign="center">
                    {title} ({tasks.length})
                </Typography>
            </Box>
            
            <Box sx={{ 
                p: 1, 
                pt: 2, 
                flex: 1, 
                overflowY: 'auto', 
                display: 'flex', 
                flexDirection: 'column', 
                gap: 1,
                // Custom scrollbar for touch accessibility
                '&::-webkit-scrollbar': {
                    width: '40px', // Extra wide for touch
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'rgba(0,0,0,0.05)', // Faint background to indicate scroll area
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#cbd5e0', // Visible handle color
                    borderRadius: '20px', // Pill shape
                    border: '10px solid transparent', // Creates padding effect inside track
                    backgroundClip: 'content-box',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#a0aec0', // Darker on interaction
                    border: '8px solid transparent', // Slightly larger on hover
                }
            }}>
                <SortableContext items={tasks.map(t => t.id)} strategy={verticalListSortingStrategy}>
                    {tasks.map((task) => (
                        <TaskCard key={task.id} task={task} />
                    ))}
                </SortableContext>
                
                {tasks.length === 0 && (
                     <Box sx={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.3 }}>
                        <Typography variant="h6" fontWeight="bold">Empty</Typography>
                     </Box>
                )}
            </Box>
        </Paper>
    );
};

export default TaskColumn;
